import React from 'react'
import Slider from './Slider'
import Clients from './Clients'
import Creativity from './Creativity'
import Digital from './Digital'
import Services from './Services'
import Business from './Business'
import Projects from './Projects'

import Views from './Views'
import ContactHome from './ContactHome'

const Blog = () => {
  return (
    <div>
        <Slider/>
        {/* <Clients/> */}
        <Creativity/>
        <Digital/>   
        <Services/>
       
        <Business/>
        <Projects/>      
        <Views/>
        <ContactHome/>
    </div>
  )
}

export default Blog